<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      module-name="tasks"
      permissions-path="TASKS"
      :get-object="getTaskObject"
      :handle-object-adding="handleTaskAdding"
      :handle-object-deleting="handleTaskDeleting"
      :handle-object-editing="handleTaskEditing"
      :init-gets="initGets"
      :inputs="inputs"
      :module-objects="tasks"
      :new-object-payload="newTaskObject"
      :toggle-object-adding="toggleTaskAdding"
      :zoom-to-object="zoomToTask"
      :name-attribute="
        attrSchemaMetadata[currentLayerSourceName]
          ? attrSchemaMetadata[currentLayerSourceName].attributes_schema.desc_attribute_name
          : ''
      "
      has-back-button
      :has-assigned-objects="false"
    >
      <template v-slot:status="scope">
        <sidebar-status-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template v-slot:assigned_user="scope">
        <user-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template v-slot:reported_by="scope">
        <user-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template v-slot:geometry="scope">
        <sidebar-geometry-input
          v-bind="scope"
          v-model="scope.payload[scope.name]"
          :is-valid.sync="scope.slotsValid[scope.name]"
        />
      </template>
    </sidebar-module-info>
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';

import SidebarGeometryInput from '@/components/SidebarGeometryInput';
import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarStatusSelect from '@/components/SidebarStatusSelect';
import UserSelect from '@/components/UserSelect';

export default {
  name: 'Task',
  components: {
    SidebarGeometryInput,
    SidebarModuleInfo,
    SidebarStatusSelect,
    UserSelect,
  },
  computed: {
    currentUser: get('users/currentUser'),
    tasks: get('tasks/tasks'),
    tasksCategories: get('tasks/tasksCategories'),
    tasksLayerId: get('admin/modulesMapping@tasks.layer_id'),
    users: get('users/users'),
    attrSchemaMetadata: get('layers/metadata'),
    currentLayerSourceName: get('layers/currentLayer@data_source_name'),
    newTaskObject() {
      const dateNow = this.$dayjs();
      const dateNowIsoString = dateNow.format('YYYY-MM-DDTHH:mm[:00.000Z]');
      if (!this.currentUser.is_superadmin && Object.keys(this.users).includes(this.currentUser.id.toString())) {
        return { reported_by: this.currentUser.id, reported_at: dateNowIsoString.slice(0, -1) };
      }
      return {};
    },
    inputs() {
      return {
        new: [
          {
            name: 'category',
            translationPath: 'dialog.category',
            icon: 'mdi-tag-multiple',
            dataType: { name: 'select' },
            items: this.tasksCategories,
            itemText: 'name',
            itemValue: 'name',
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'tasks',
            rules: [v => !!v || v == '0' || 'rules.required'],
            colors: {
              new: {
                color: 'rgba(0,145,234)',
                shadowColor: 'rgba(0,145,234,0.2)',
              },
              done: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              in_progress: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
              planned: {
                color: 'rgba(108,108,108)',
                shadowColor: 'rgba(108,108,108,0.2)',
              },
            },
          },
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'description',
            translationPath: 'dialog.description',
            icon: 'mdi-information',
            dataType: { name: 'textarea' },
            autoGrow: true,
            dense: true,
            rows: '1',
            hasDivider: true,
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hint: this.$i18n.t('dialog.taskGeometryInputHint'),
            geometryType: 'Polygon',
            hasAssignGeometry: true,
            assignGeometryType: 'Polygon',
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
          {
            name: 'assigned_user',
            translationPath: 'dialog.assignedPerson',
            icon: 'mdi-account-arrow-left',
          },
          {
            name: 'due_date',
            translationPath: 'dialog.timeLimit',
            icon: 'mdi-calendar',
            dataType: { name: 'date' },
          },
        ],
        edit: [
          {
            name: 'category',
            translationPath: 'dialog.category',
            icon: 'mdi-tag-multiple',
            dataType: { name: 'select' },
            items: this.tasksCategories,
            itemText: 'name',
            itemValue: 'name',
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'tasks',
            rules: [v => !!v || v == '0' || 'rules.required'],
            colors: {
              new: {
                color: 'rgba(0,145,234)',
                shadowColor: 'rgba(0,145,234,0.2)',
              },
              done: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              in_progress: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
              planned: {
                color: 'rgba(108,108,108)',
                shadowColor: 'rgba(108,108,108,0.2)',
              },
            },
          },
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'description',
            translationPath: 'dialog.description',
            icon: 'mdi-information',
            dataType: { name: 'textarea' },
            autoGrow: true,
            dense: true,
            rows: '1',
            hasDivider: true,
          },
          {
            name: 'reported_by',
            translationPath: 'dialog.reportingPerson',
            icon: 'mdi-account-arrow-right',
            rules: [v => !!v || v == '0' || this.$i18n.t('rules.required')],
            readOnlyField: true,
          },
          {
            name: 'reported_at',
            translationPath: 'dialog.reportedAt',
            icon: 'mdi-calendar',
            hasDivider: true,
            readOnlyField: true,
            dataType: { name: 'datetime' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            hasNameColumn: false,
            oneLineInput: false,
            sectionTitle: 'sidebar.geometrySectionTitle',
            cols: '12',
            hint: this.$i18n.t('dialog.taskGeometryInputHint'),
            geometryType: 'Polygon',
            hasAssignGeometry: true,
            assignGeometryType: 'Polygon',
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
          {
            name: 'assigned_user',
            translationPath: 'dialog.assignedPerson',
            icon: 'mdi-account-arrow-left',
          },
          {
            name: 'due_date',
            translationPath: 'dialog.timeLimit',
            icon: 'mdi-calendar',
            dataType: { name: 'date' },
            hasDivider: true,
          },
        ],
      };
    },
  },
  methods: {
    addTask: call('tasks/addTask'),
    deleteTask: call('tasks/deleteTask'),
    editTask: call('tasks/editTask'),
    getTask: call('tasks/getTask'),
    getTasksCategories: call('tasks/getTasksCategories'),
    toggleTaskAdding() {
      this.$router.push({
        name: 'task',
        params: { fid: 'new' },
      });
    },
    zoomToTask(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
    async getTaskObject(id) {
      const r = await this.getTask(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleTaskAdding(payload) {
      const feature = {
        ...payload,
      };
      const r = await this.addTask(feature);
      this.$root.$emit('refreshNavbarInfoButtons', ['tasks']);
      return r.data.data;
    },
    async handleTaskDeleting(payload) {
      await this.deleteTask(payload);
      this.$root.$emit('refreshNavbarInfoButtons', ['tasks']);
    },
    async handleTaskEditing(payload) {
      const task_id = payload.id;
      delete payload.id;
      if (payload.assigned_user === null) {
        delete payload.assigned_user;
      }
      const feature = {
        ...payload,
      };
      await this.editTask({ task_id, feature });
    },
    async initGets() {
      await this.getTasksCategories();
    },
  },
};
</script>
